module.exports = __webpack_public_path__ + "img/okaml.533ec8e0.svg";